import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import { reviewMetricMap, scOmitMetricMap } from 'utils';
import {
  MetricDripSvg,
  MetricFlowerSvg,
  MetricStarSvg,
} from 'components/SorraSvg';

const ReviewMetrics = (props) => {
  const { categoryIds = [], metrics = [], className = '', textClassName = '', iconSize = 'h-4 w-4' } = props;
  let filteredMetrics = metrics;

  for (var i = 0; i < categoryIds.length; i++) {
    const categoryId = categoryIds[i];
    if (scOmitMetricMap[categoryId]) {
      filteredMetrics = _.filter(filteredMetrics, (metric) => {
        return !_.includes(scOmitMetricMap[categoryId], metric.review_metric);
      });
    }
  }

  return (
    <div
      className={classnames(
        'flex items-center gap-x-1 text-xs text-sorra-gray-800',
        className
      )}
    >
      {filteredMetrics.map((m, idx, arr) => {
        return (
          <React.Fragment key={m.id}>
            <p className={textClassName}>{reviewMetricMap[m.review_metric]}</p>
            <div className="flex items-center">
              {Array((m.score || 0) + 1)
                .fill(0)
                .map((_, i) => {
                  return (
                    <div
                      key={`${i}_${m.review_metric}_${m.score}`}
                      className={iconSize}
                    >
                      {m.review_metric === 1 ? (
                        <MetricDripSvg />
                      ) : m.review_metric === 2 ? (
                        <MetricFlowerSvg />
                      ) : m.review_metric === 3 ? (
                        <MetricStarSvg />
                      ) : null}
                    </div>
                  );
                })}
            </div>
            {arr.length - 1 !== idx ? (
              <div className="text-sorra-gray-500">|</div>
            ) : null}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ReviewMetrics;
